import { DeliverableStatus } from "models/IProjectIQWorkspace";
import {
  MilestoneStatus,
  RaidStatus,
} from "apps/project-iq/components/WorkspacePlan/WorkspacePlan.types";

export const MILESTONE_STATUS_LABELS: Record<MilestoneStatus, string> = {
  not_started: "Not Started",
  in_progress: "In Progress",
  done: "Done",
};

export const DELIVERABLE_STATUS_LABELS: Record<DeliverableStatus, string> = {
  not_started: "Not Started",
  in_progress: "In Progress",
  done: "Done",
};

export const RAID_STATUS_LABELS: Record<RaidStatus, string> = {
  not_started: "Not Started",
  in_progress: "In Progress",
  closed: "Closed",
};
